import React, { Component } from "react";
import { TimelineMax, Back } from "gsap";

class Contact extends Component {
  componentDidMount() {
    this.tl = new TimelineMax({ delay: 0, ease: Back.easeOut, paused: true });
  }

  enterTransition = time => {
    this.tl.fromTo(
      this.component,
      time,
      { opacity: 0, transform: "translateY(-150px)" },
      { opacity: 1, transform: "translateY(0px)" }
    );
    this.tl.play();
  };

  exitTransition = time => {
    this.tl.fromTo(
      this.component,
      time,
      { opacity: 1 },
      { transform: "translateY(-70px)", opacity: 0 }
    );
    this.tl.play();
  };

  render = () => {
    return (
      <div className="contact">
        <a href="mailto:hi@joja.agency">
          <div className="contactEmail" ref={c => (this.component = c)}>
            hi@joja.agency
          </div>
        </a>
      </div>
    );
  };
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js